import React from "react";
import { Link } from "react-router-dom";
const ProjectImg = ({ project }) => {
  const { name, icon_url, live, repo, _id } = project;

  return (
    //     <!-- component -->
    // <!--
    //   You must enable group-hover in `tailwind.config.js` for the following prop
    //   ...
    //   variants: {
    //     extend: {
    //       ...,
    //       inset: ["group-hover"],
    //     }
    //   }
    // -->
    <div
      data-aos="zoom-out-up"
      data-aos-duration="1500"
      className="relative group w-96 h-96 overflow-hidden bg-black m-auto mt-36 "
    >
      <img
        className="object-cover w-full h-full transform duration-700 backdrop-opacity-500 rounded"
        src={icon_url}
        alt=""
      />
      <div className="absolute w-full h-full shadow-4xl bg-dark transform duration-500 inset-y-full group-hover:-inset-y-20"></div>
      <div className="absolute bg-gradient-to-t from-black w-full h-full transform duration-500 inset-y-3/4 group-hover:-inset-y-0">
        <div className="absolute w-full flex place-content-center">
          <p className="capitalize font-serif font-bold text-3xl text-center shadow-2xl text-rose-600  mt-10">
            {name}
          </p>
        </div>
        <div className="absolute w-full flex place-content-center mt-60">
          <button className="absolute left-1/4 bottom-4 bg-pink-600 text-white font-bold rounded-lg h-10 w-48">
            <a href={live} target="_blank" noopener rel="noreferrer">
              LIVE LINK
            </a>
          </button>
        </div>

        <div className="flex">
          <Link to={`/detailsService/${_id}`}>
            <button className="absolute left-1/4 bottom-4 bg-pink-600 text-white font-bold rounded-lg h-10 w-48">
              {/* <a href={repo} target="_blank" noopener rel="noreferrer">
                DETAILS
              </a> */}
              DETAILS
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProjectImg;
